import React from 'react';
import TradingScoreWidgetBuilder from './TradingScoreWidgetBuilder';
import TradingScoreWidgetRenderer from './TradingScoreWidgetRenderer';
import Preview from './Preview';
import Summary from './Summary';
import type { WidgetDefinition } from '../../../registry';
import type { TradingScoreWidgetConfig, TradingScoreDataContent } from './types';
import { TRADING_SCORE_OPTIONS } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTrendUp } from '@fortawesome/free-solid-svg-icons';

export { default as TradingScoreWidgetBuilder } from './TradingScoreWidgetBuilder';
export { default as TradingScoreWidgetRenderer } from './TradingScoreWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'trading_score',
  meta: {
    label: 'Action Buttons',
    icon: React.createElement(FontAwesomeIcon, { icon: faArrowTrendUp }),
    description: 'Select one of six actions',
    isSystem: true,
    isCreatable: false,
    dataFlow: 'input',
    summaryEligible: true,
    lastUpdated: '2026-04-23',
  },
  defaultSize: { w: 6, h: 3, minW: 5, minH: 3 },
  defaultConfig: () => ({ } as TradingScoreWidgetConfig),
  Builder: TradingScoreWidgetBuilder,
  Renderer: TradingScoreWidgetRenderer,
  Preview,
  Summary,
  sampleSummaryData: [
    { action: 'buy_to_add' },
    { action: 'maintain' },
    { action: 'exit' },
    undefined,
  ],
  validate: (data: unknown): string[] => {
    const tradingScoreData = data as TradingScoreDataContent | undefined;
    if (!tradingScoreData?.action) {
      return ['A trading action selection is required'];
    }
    // Guard against corrupt/imported data carrying an action outside the
    // fixed set (the UI itself can only produce valid values).
    if (!TRADING_SCORE_OPTIONS.some((o) => o.value === tradingScoreData.action)) {
      return [`Invalid action "${tradingScoreData.action}"`];
    }
    return [];
  },
};
